module.exports = __webpack_public_path__ + "img/genre4.952c35d6.svg";